:host {
  display: block;
  height: 100%;

  *,
  :after,
  :before {
    box-sizing: border-box;
    outline: 0 none;
    text-rendering: optimizelegibility;
  }
}

:host(.#{$prefix}grow) {
  @include for-size(desktop-or-larger) {
    flex-grow: 1;
  }
}

:host(.#{$prefix}grow-mobile) {
  @include for-size(tablet-or-smaller) {
    flex-grow: 1;
  }
}

:host(.#{$prefix}visible-on-mobile) {
  display: none;

  @include for-size(tablet-or-smaller) {
    display: block;
  }
}

:host(.#{$prefix}visible-on-desktop) {
  display: none;

  @include for-size(desktop-or-larger) {
    display: block;
  }
}

.#{$prefix}column-wrapper {
  position: relative;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: stretch;

  &.#{$prefix}alignment-left {
    justify-content: flex-start;
  }

  &.#{$prefix}alignment-center {
    justify-content: center;
  }

  &.#{$prefix}alignment-right {
    justify-content: flex-end;
  }

  &.#{$prefix}alignment-mobile-left {
    @include for-size(tablet-or-smaller) {
      justify-content: flex-start;
    }
  }

  &.#{$prefix}alignment-mobile-center {
    @include for-size(tablet-or-smaller) {
      justify-content: center;
    }
  }

  &.#{$prefix}alignment-mobile-right {
    @include for-size(tablet-or-smaller) {
      justify-content: flex-end;
    }
  }
}
